module.exports = __webpack_public_path__ + "img/ErstmalPause.c72bf732.jpg";